'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prompt = (0, _glamor.css)({
  position: 'fixed',
  display: 'block',

  width: 540,
  height: 'auto',

  left: '50%',
  top: '50%',

  transform: 'translate(-50%, -50%)',

  padding: (0, _css.unitRem)(2),

  color: _css.colors.gray,
  background: _css.colors.medDarkGray3,

  boxShadow: '0 0 20px 5px rgba(0, 0, 0, 0.5)',

  borderRadius: 6,

  zIndex: 1
});

var promptQuestion = (0, _glamor.css)({
  margin: (0, _css.unitRem)(1) + ' 0',
  whiteSpace: 'pre-line'
});

var promptButtons = (0, _glamor.css)({
  float: 'right',
  marginTop: (0, _css.unitRem)(1)
});

var promptButton = (0, _glamor.css)({
  marginRight: (0, _css.unitRem)(1),

  '&:last-child': {
    marginRight: 0
  },

  '& button': {
    minWidth: 120
  }
});

var DialogBox = function (_React$Component) {
  (0, _inherits3.default)(DialogBox, _React$Component);

  function DialogBox() {
    (0, _classCallCheck3.default)(this, DialogBox);
    return (0, _possibleConstructorReturn3.default)(this, (DialogBox.__proto__ || (0, _getPrototypeOf2.default)(DialogBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(DialogBox, [{
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Prompt.scss');

      return _react2.default.createElement(
        'div',
        { className: prompt },
        _react2.default.createElement(
          'div',
          { className: promptQuestion },
          _react2.default.createElement(
            'p',
            null,
            this.props.question
          )
        ),
        _react2.default.createElement(
          'div',
          { className: promptButtons },
          _react2.default.createElement(_Button2.default, { mode: 'normal', small: true, className: promptButton, label: 'Cancel', onClick: function onClick() {
              return _this2.props.onCloseNo();
            } }),
          _react2.default.createElement(_Button2.default, { mode: 'secondary', small: true, className: promptButton, label: 'Ok', onClick: function onClick() {
              return _this2.props.onCloseYes('yes');
            } })
        )
      );
    }
  }]);
  return DialogBox;
}(_react2.default.Component);

exports.default = DialogBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/Prompt.jsx
// module id = 2654
// module chunks = 0